import { render } from "./Base.vue?vue&type=template&id=6f7ae281"
import script from "./Base.vue?vue&type=script&lang=js"
export * from "./Base.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/www.alb-bayern.de/bottle/www/apps/alb_development/frontend/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Base.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f7ae281"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f7ae281', __exports__)) {
    console.log('reload')
    api.reload('6f7ae281', __exports__)
  }
  
  module.hot.accept("./Base.vue?vue&type=template&id=6f7ae281", () => {
    console.log('re-render')
    api.rerender('6f7ae281', render)
  })

}


export default __exports__